// extracted by mini-css-extract-plugin
export default {"analysis-repeat-collect":"repeatCollect_analysis-repeat-collect__ZedyX"};